import React, { PropsWithChildren } from 'react';
import { usePostHogTracking } from '../../hooks/usePostHogTracking';

/**
 * Provider component that initializes PostHog error tracking integration
 * This component should be placed within the AuthProvider to ensure
 * user context is available when setting up error tracking
 */
export const ErrorTrackingProvider: React.FC<PropsWithChildren> = ({ children }) => {
  // Initialize PostHog tracking with auth state synchronization
  usePostHogTracking();

  return <>{children}</>;
};
